var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2964 11.0002L17.1484 6.14827C17.5068 5.79077 17.5068 5.20966 17.1484 4.85216C16.7899 4.49374 16.2106 4.49374 15.8522 4.85216L11.0003 9.70404L6.14835 4.85216C5.78994 4.49374 5.2106 4.49374 4.85219 4.85216C4.49377 5.20966 4.49377 5.79077 4.85219 6.14827L9.7041 11.0002L4.85219 15.8522C4.49377 16.2097 4.49377 16.7908 4.85219 17.1483C5.03094 17.327 5.2656 17.4169 5.50027 17.4169C5.73494 17.4169 5.9696 17.327 6.14835 17.1483L11.0003 12.2964L15.8522 17.1483C16.0309 17.327 16.2656 17.4169 16.5003 17.4169C16.7349 17.4169 16.9696 17.327 17.1484 17.1483C17.5068 16.7908 17.5068 16.2097 17.1484 15.8522L12.2964 11.0002Z",
    fill: "#25314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.7585f5bc305972bcdb509c975010b7f9.svg";
export { ForwardRef as ReactComponent };